// generated from 52 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const uninstallFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("uninstall_filter"),
  comparison_key: z.enum([
    "6", // 22 (42.31%)
    "4", // 20 (38.46%)
    "3", // 6 (11.54%)
    "5", // 4 (7.69%)
  ]),
  display_name: z.string(),
  // undefined: 6 (11.54%), defined 46 (88.46%)
  raw_value: z
    .union([
      // number samples: 39 (84.78%)
      z.int(),
      // string samples: 7 (15.22%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 42 (80.77%)
    // integer: 41 (97.62%)
    // avg: 17.57, min: 0.125, max: 37
    z.number().nonnegative(),
    // string samples: 10 (19.23%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
